import { createRouter, createWebHistory } from "vue-router";
import Concern from "@/components/Concern.vue";
import Crops from "@/components/Crops.vue";
import Data from "@/components/Data.vue";
import Home from "@/components/Home.vue";
import Map from "@/components/Map.vue";
import MyLoad from "@/components/MyLoad.vue";

const routes = [
  { path: "/", component: Home },
  { path: "/concern", component: Concern },
  { path: "/my-load", component: MyLoad },
  { path: "/data", component: Data },
  { path: "/crops", component: Crops },
  { path: "/map", component: Map }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
